export default __webpack_public_path__ + "static/media/1.5ef00eb8.jpg";